import { Component, OnInit, SecurityContext } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TestSerService } from 'src/app/services/test-ser.service';
import { FundService } from 'src/app/services/fund.service'
import { DomSanitizer } from '@angular/platform-browser';
import { Chart } from 'angular-highcharts';
import postscribe from 'postscribe';
import * as CanvasJS from '../canvasjs.min';

import * as Highcharts from 'highcharts';


// import { Chart } from 'canvasjs'

const httpOptions = {
  headers: new HttpHeaders({
    'Access-Control-Allow-Origin': '*'
  })
};

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})


export class TestComponent implements OnInit {

  html: any
  x: any

  chart: any

  seriesData = []
  fundDateData = []

  dataChart: Array<any> = []
  labelChart: Array<any> = []
  ChartName: any
  minVal : any =0
  maxVal : any = 0

  constructor(private _http: HttpClient, private _testServ: TestSerService,
    private _sanitizer: DomSanitizer, private fundserv: FundService) { }

  ngOnInit() {

    // this.fundserv.GetNAVHistory('72').subscribe(response => {
    //   var i: number;
    //   if (response['Result'].length > 25) {
    //     for (i = 24; i >= 0; i--) {
    //       if(this.minVal == 0){
    //         this.minVal = response['Result'][i]['NavPublish']
    //       }
    //       else{
    //         if(response['Result'][i]['NavPublish'] <  this.minVal){
    //           this.minVal = response['Result'][i]['NavPublish']
    //         }
    //       }

    //       if(this.maxVal == 0){
    //         this.maxVal = response['Result'][i]['NavPublish']
    //       }
    //       else{
    //         if(response['Result'][i]['NavPublish'] >  this.maxVal){
    //           this.maxVal = response['Result'][i]['NavPublish']
    //         }
    //       }

    //       this.dataChart.push(response['Result'][i]['NavPublish'])
    //       this.labelChart.push(response['Result'][i]['FundPriceDate'].substring(0, 10))
    //     }
    //   }
    //   else {
    //     for (i = response['Result'].length - 1; i >= 0; i--) {
    //       this.dataChart.push(response['Result'][i]['NavPublish'])
    //       this.labelChart.push(response['Result'][i]['FundPriceDate'].substring(0, 10))
    //     }
    //   }

    //   this.chart = new Chart({
    //     chart: {
    //       type: 'area',
    //       styledMode: true,
    //       zoomType: 'x'
    //     },
    //     legend: {
    //       align: 'left'
    //     },
    //     title: {
    //       text: null
    //     },
    //     xAxis: {
    //       categories: this.labelChart,
    //     },
    //     yAxis: {
    //       min : this.minVal,
    //       max : this.maxVal,
    //       title: {
    //         text: null
    //       }
    //     },
    //     defs: {
    //       gradient0: {
    //         tagName: 'linearGradient',
    //         id: 'gradient-0',
    //         x1: 0,
    //         y1: 0,
    //         x2: 0,
    //         y2: 1,
    //         children: [{
    //           tagName: 'stop',
    //           offset: 0
    //         }, {
    //           tagName: 'stop',
    //           offset: 1
    //         }]
    //       },
    //       gradient1: {
    //         tagName: 'linearGradient',
    //         id: 'gradient-1',
    //         x1: 0,
    //         y1: 0,
    //         x2: 0,
    //         y2: 1,
    //         children: [{
    //           tagName: 'stop',
    //           offset: 0
    //         }, {
    //           tagName: 'stop',
    //           offset: 1
    //         }]
    //       }
    //     },
    //     series: [{
    //       type: undefined,
    //       name: 'test chart xxx',
    //       data: this.dataChart
    //     }]
    //   });











    // })

  }



}

